<template>
  <div class="list-view company-users">
    <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
    <!-- <TableGutter :tools="tableColOpts.gutterOpts" :selectedAction="false" @re-render-table="">
    </TableGutter> -->
    <mf-table ref="assembliesTable" :tableProps="tableColOpts" :loadData="loadData" :hideGutter="true" :apiMode="true"
      :key="refresh" @cell-clicked="onCellClicked" @refreshTable="refresh++">
      <template v-slot:appVersion="{ rowData }">
        <span v-if="rowData.lastLoginAppVersion && rowData.lastLoginPlatform">
          {{ rowData.lastLoginAppVersion }},
          {{ rowData.lastLoginPlatform }}
        </span>
      </template>
    </mf-table>

    <user-form-modal v-if="isActive" :isActive="isActive" @close="closeUserFormModal"
      :mode="selectedUser ? 'edit' : 'create'" :user="selectedUser"></user-form-modal>
    <activity-slider :isActive="showActivityHistory" :company="$store.state.userData.company" :module="'User'"
      @update:isActive="showActivityHistory = false" />
    <excel-import :isExcelModalActive="excelModal" :type="'users'" :importModule="'users-import'"
       :validateExcelItem="(data) => validationChecks(data)"
       :uniqueFields="['email']"
      :saveExcelItem="saveExcelItem"
      :isProgressBar="true"
      :modalHeaderTitle="excelImportModalText" @close-modal="closeExcelModal" @refresh-table="refresh++"></excel-import>
  </div>
</template>
<script>
import { onUpdated, reactive, ref, toRefs, computed } from "vue";
import { useStore } from 'vuex';
import DataTable from "@/components/table-fields/DataTable.vue";
import TableToolbar from "@/components/table-fields/TableToolbar.vue";
import UserFormModal from "@/components/modals/UserFormModal.vue";
import usersListCols from "@/components/table-cols/usersListCols.js";
import TableGutter from "@/components/TableGutter.vue";
import Projects from '@/models/Projects';
import Users from '@/models/Users';
import Companies from '@/models/Companies';
import ActivitySlider from "@/components/ActivitySlider.vue";
import { useToast } from 'vue-toastification';
import { DialogProgrammatic } from '@/components/Dialog';
import MfTable from '@/components/table-fields/MfTable.vue';
import ExcelImport from '@/components/ExcelImport.vue';
import Validation from '@/components/utils/Validations';
import _ from 'lodash';

export default {
  name: "Users",
  components: {
    DataTable,
    TableToolbar,
    TableGutter,
    UserFormModal,
    ActivitySlider,
    'mf-table': MfTable,
    'excel-import': ExcelImport,
  },
  setup() {
    const store = useStore();
    const data = reactive({
      tableColOpts: usersListCols,
      isActive: false,
      selectedUser: null,
      refresh: 0,
      searchQuery: '',
      showActivityHistory: false,
      isLoading: false,
      excelModal: false,
      excelImportModalText: 'Import Users from Excel',
    });
    const viewOnlyMemberGroup = store.state.availablePermissionGroups.find(group => group.name === 'View Only Member');
    const toast = useToast();


    const loadData = async (commonParam, e) => {

      const params = {
        companyId: store.state.userData.company,
        showUsers: 'all',
        ...commonParam,
        searchText: commonParam.search,
        sort: { [commonParam.sort[0].sortField === 'name' ? 'firstName' : commonParam.sort[0].sortField]: commonParam.sort[0].direction === 'asc' ? 1 : -1 }
      };
      const roles = store.state.queryParams?.role?.map(role => role._id) || [];
      if (roles.length) {
        params.roles = roles;
      }
      const permissionGroupsFilter = store.state.queryParams?.permissionGroup?.map(group => group._id) || [];
      if (permissionGroupsFilter.length) {
        params.permissionGroups = permissionGroupsFilter;
      }
      const licensedUser = store.state.queryParams?.licensedUser?.[0]?.value;
      if (['licensed', 'unlicensed'].includes(licensedUser)) {
        params.isLicensedUser = licensedUser === 'licensed';
      }
      const inAllProjects = store.state.queryParams?.autoAdd?.[0]?.value;
      if (['yes', 'no'].includes(inAllProjects)) {
        params.inAllProjects = inAllProjects === 'yes';
      }

      const resp = await Users.allUsers(params);
      const permissionGroups = _.keyBy(store.state.availablePermissionGroups, '_id');
      resp.data = resp.data.map(user => {
        const currentCompanyPermission = user.permissionSettings?.find(perm => perm.company === store.state.userData.company);
        user.groupName = permissionGroups[currentCompanyPermission?.groups[0]]?.name || 'No Group';
        return user;
      });
      return {
        data: resp.data,
        total: resp.data.length ? resp.data.total : 0,
      };
    };

    const resendMail = async (user) => {
      if (user.activated) {
        toast.error('User is already active');
        return;
      }
      await Users.sendActivationMail({ id: user._id });
      toast.success('Activation email sent');
      return;
    };

    const resendActivateUser = async (user) => {
      if (user._statusForCompany !== 'Archived') {
        toast.error('User is already active or inactive');
        return false;
      }
      const confirmParam = {
        title: 'Are you Sure?',
        message: `You want to activate user?"`,
        okButton: 'Yes',
        cancelButton: 'No',
        type: '',
        onConfirm: async () => {
          try {
            await Users.resendActivateUser({ id: user._id });
            toast.success('User activated');
            data.refresh++;

          } catch (error) {
            toast.error('Error activating user: please contact ManufactOn support');
          }
        },
      };
      DialogProgrammatic.confirm(confirmParam);
    };

    const archiveUser = async (user) => {
      const userCompany = await Companies.getOne(store.state.userData.company);
      if (user._id.toString() === userCompany.owner.toString()) {
        toast.error('Company Owner can not be Deleted Please contact Manufacton');
      } else {
        const confirmParam = {
          title: 'Are you Sure?',
          message: `You want to archive user?"`,
          okButton: 'Archive',
          cancelButton: 'Cancel',
          type: '',
          onConfirm: async () => {
            try {
              data.isLoading = true;
              if (user.viewOnlyMember) {
                await Users.archiveViewMember(user);
              } else {
                await Users.archiveCompanyUser(user);
              }
              toast.success('User archived');
              data.refresh++;

            } catch (error) {
              toast.error('Error archiving user: please contact ManufactOn support');
            } finally {
              data.isLoading = false;
            }
          }
        };
        DialogProgrammatic.confirm(confirmParam);
      };
    };

    const onCellClicked = async (payload) => {
      if (payload.type === 'addNew') {
        data.selectedUser = null;
        data.isActive = true;
      };
      if (payload.type === 'editUser') {
        data.selectedUser = payload.data;
        data.isActive = true;
      }
      if (payload.type === 'search') {
        data.searchQuery = payload.data;
        data.refresh++;
      }
      if (payload.type === 'openActivityHistory') {
        data.showActivityHistory = true;
      }
      if (payload.type === 'resendMail') {
        await resendMail(payload.data);
      } else if (payload.type === 'resendActivateUser') {
        await resendActivateUser(payload.data);
      } else if (payload.type === 'member-archive') {
        await archiveUser(payload.data);
      } else if (payload.type === 'excelImport') {
        data.excelModal = true;
      }

    };

    const closeExcelModal = () => {
      data.excelModal = false;
    };

    const validationChecks = (data) => {
      const firstName = (data.firstName).trim();
      const lastName = (data.lastName).trim();
      const namePattern = /^[a-zA-Z']+$/;
      if (_.isEmpty(firstName) || firstName.length < 3) {
        return 'Name must be at least three characters long';
      } else if (!namePattern.test(firstName)) {
        return 'First name cannot contain spaces, numbers, or special characters';
      } else if (_.isEmpty(lastName) || lastName.length < 1) {
        return 'Last name must be at least one character long';
      } else if (!namePattern.test(lastName)) {
        return 'Last name cannot contain spaces, numbers, or special characters';
      } else if (_.isEmpty(data.email)) {
        return 'Email is mandatory';
      } else if (!_.isEmpty(data.email) && !Validation.validateEmail(data.email)) {
        return 'Please enter a valid email';
      } else if (!_.isEmpty(data.mobilePhone)
        && !Validation.validatePhoneNumber(data.mobilePhone)) {
        return 'Valid range for phone number length is 1 - 24!';
      }
      
    };

    const saveExcelItem = async (obj) => {
      const params = {
        firstName: (obj.firstName).trim(),
        lastName: (obj.lastName).trim(),
        hasReservedLicense: false,
        permissionGroups: [viewOnlyMemberGroup._id],
        company: store.state.userData.company,
        email: obj.email,
        isAdmin: false,
      }
      if(obj.mobilePhone) {
        params.mobilePhone = obj.mobilePhone.toString().trim();
      }
      const roles = ['assistant-project-manager', 'coordinator', 'detailer', 'estimator',
      'field-super', 'inventory-manager', 'partner', 'procurement-manager', 'project-engineer',
      'project-manager', 'project-executive', 'qa', 'shipping-manager', 'shop-super'];

      if (!_.isEmpty(obj.role) && roles.includes(_.kebabCase(obj.role))) {
        params.role = _.kebabCase(obj.role);
      } else {
        params.role = 'coordinator';
      }
      return await Users.editUser(params);
    };

    const closeUserFormModal = (payload) => {
      data.isActive = false;
      data.selectedUser = null;
      if (payload?.refresh)
        data.refresh++;
    };

    return {
      ...toRefs(data),
      loadData,
      onCellClicked,
      closeExcelModal,
      validationChecks,
      saveExcelItem,
      closeUserFormModal
    };
  },
};
</script>

